import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Products from "./components/Products";
import About from "./components/About";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";

function App() {
  const scrollToProducts = () => {
    document.getElementById("products")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="page-wrapper bg-white">
      <Navbar />
      <main>
        <Hero />
        <Products />
        <About />
        <Features />
        <Testimonials />
        <CTABanner />
        <Footer />
      </main>

      {/* Mobile sticky bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-3 bg-white/95 backdrop-blur-md border-t border-orange-100 md:hidden z-40 shadow-lg">
        <button
          onClick={scrollToProducts}
          className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-full py-3.5 font-bold text-base shadow-lg hover:shadow-orange-500/40 transition-all duration-200"
          data-testid="mobile-sticky-cta"
        >
          Shop Now
        </button>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://api.whatsapp.com/send/?phone=919771479798&text=Hello+I+would+like+to+inquire+about+your+services&type=phone_number&app_absent=0"
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-[88px] md:bottom-8 right-4 md:right-6 z-50 bg-[#25D366] text-white p-3 sm:p-3.5 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 flex items-center justify-center"
        aria-label="Chat on WhatsApp"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
          alt="WhatsApp Logo" 
          className="w-7 h-7 sm:w-8 sm:h-8" 
        />
      </a>
    </div>
  );
}

export default App;
